document.addEventListener('DOMContentLoaded', function () {
  const variantsScript = document.querySelector('#qb-variants-json');
  if (!variantsScript) return;

  let productVariants;
  try {
    productVariants = JSON.parse(variantsScript.textContent);
  } catch (err) {
    return;
  }

  document.querySelectorAll('.variant-selector-container').forEach(function (container) {
    container.addEventListener('variantSelected', function (e) {
      const variantId = e.detail && e.detail.variant && e.detail.variant.variantId;
      if (!variantId) return;

      const matchedVariant = productVariants.find(function (v) {
        return String(v.id) === String(variantId);
      });

      if (!matchedVariant || !matchedVariant.featured_media) return;

      document.dispatchEvent(new CustomEvent('variant:imageChanged', {
        detail: {
          variantId: matchedVariant.id,
          image: matchedVariant.featured_image,
          mediaId: matchedVariant.featured_media.id
        }
      }));
    });
  });
});